module.exports = __webpack_public_path__ + "frontend/images/023a4f575f0505957fd2da9e6fed2d86.png";